import { createContext } from 'react';

/**
 * Distinct customer-assigned device tags across the fleet, for the pilot
 * editor's tag picker. Derived from each device's `metadata.tags`.
 * Alphabetical; empty/non-string entries dropped.
 */
export function deriveTagOptions(
  metadatas: readonly (Record<string, unknown> | null)[],
): string[] {
  const set = new Set<string>();
  for (const m of metadatas) {
    const raw = m?.['tags'];
    if (!Array.isArray(raw)) continue;
    for (const t of raw) {
      if (typeof t === 'string' && t.trim().length > 0) set.add(t.trim());
    }
  }
  return [...set].sort((a, b) => a.localeCompare(b));
}

/**
 * Tags observed across the tenant's live devices, provided by BuilderEditor
 * and consumed by the per-tile pilot editor's tag picker. Defaults to empty.
 */
export const PilotTagsContext = createContext<readonly string[]>([]);
